import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import {
  getNetServiceRevenue,
  getNewCustomers,
  getProductCount,
  getServiceCount,
  getNetProductRevenue,
  getTotalRevenue,
  getTotalRevenueWithTax,
} from './selectors';
import Analytics from './components/Analytics';
import withNewDesignStyles from '../../../common/hoc/withNewDesignStyles';
import {
  isBarberUser,
  getCurrency, isBrandViewActive,
} from '../../../auth/selectors';
import Fetcher from './hoc/Fetcher';
import { getGrossSalesKind } from '../helpers';

export default compose(
  withNewDesignStyles,
  Fetcher,
  connect(
    state => ({
      totalSales: getTotalRevenue(state),
      totalSalesWithTax: getTotalRevenueWithTax(state),
      netServiceRevenue: getNetServiceRevenue(state),
      serviceCount: getServiceCount(state),
      netProductRevenue: getNetProductRevenue(state),
      productCount: getProductCount(state),
      newCustomers: getNewCustomers(state),
      showBarberSelector: !(isBarberUser(state) || isBrandViewActive(state)),
      showShopSelector: isBrandViewActive(state),
      grossSalesKind: getGrossSalesKind(getCurrency(state), true),
    }),
  ),
  withHandlers({
    onDateChange: ({ filters, setFilters, fetch }) => (firstFrom, firstTo, secondFrom, secondTo) => {
      const newFilters = {
        ...filters,
        firstFrom,
        firstTo,
        secondFrom,
        secondTo,
      };
      setFilters(newFilters);
      return fetch(newFilters);
    },
    onBarberChange: ({ filters, setFilters, fetch }) => (selectedBarberId) => {
      const newFilters = {
        ...filters,
        selectedBarberId,
      };
      setFilters(newFilters);
      return fetch(newFilters);
    },
  })
)(Analytics);
